// extracted by mini-css-extract-plugin
module.exports = {"btn":"back_btn__Ov976"};